import React, { useEffect, useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { Link, Redirect, Route, Switch } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_augmentt'
import '../../../_augmentt/_assets/sass/pages/login/login-1.scss'
import ChangePassword from './ChangePassword'
import ConfirmUser from './ConfirmUser'
import ForgotPassword from './ForgotPassword'
import Login from './Login'
import LoginRaysBackground from './LoginBackgroundAnimation/LoginBackgroundAnimation'

export default function AuthPage(authProps) {
  const { redirectUrl = false, navSearchParams = false } = authProps

  useEffect(() => {
    // If a user is redirected to the Login component from any paths other than
    // /auth/login or /error or /logout then they should be brought back there after login
    if (redirectUrl) {
      const navString = `${redirectUrl}${navSearchParams || ''}`

      localStorage.setItem('redirectUrl', navString)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const year = new Date().getFullYear()

  const captchaRef = useRef(null)

  // Always Augmentt on auth routes — not tenant `branding` from Redux, which can linger after logout
  // and would incorrectly white-label the sign-in screen for the next visitor on the same browser.

  return (
    <div className="login row row-full-height row-no-padding">
      <div className="col-xl-12 login__layout login__layout--themed">
        <LoginRaysBackground className="login__background-rays" />
        <div className="login__layout--themed-foreground">
          <div aria-live="polite" aria-atomic="true" className="login__a11y-region" />
          <div className="row justify-content-center login__content">
            <div className="col-sm-12 col-md-7 col-lg-5" id="authForm">
              <Link to="/" className="login__logo">
                <img
                  className="login__logo-mark login__logo-mark--for-light-ui"
                  alt="Augmentt"
                  src={toAbsoluteUrl('/media/logos/logo-dark.svg')}
                />
                <img
                  className="login__logo-mark login__logo-mark--for-dark-ui"
                  alt="Augmentt"
                  src={toAbsoluteUrl('/media/logos/logo-light.svg')}
                />
              </Link>
              <div className="login__wrapper">
                <Switch>
                  <Route path="/auth/login" render={(props) => <Login {...props} captcha={captchaRef.current} />} />
                  <Route path="/auth/forgot-password" component={ForgotPassword} />
                  <Route path="/auth/change-password" component={ChangePassword} />
                  <Route path="/auth/confirm" component={ConfirmUser} />
                  <Redirect from="/auth" exact to="/auth/login" />
                  <Redirect from="/" exact to="/auth/login" />
                  <Redirect exact to="/auth/login" />
                </Switch>
              </div>
            </div>
          </div>
          <div className="login__info">
            <div className="login__copyright">&copy; {year} AUGMENTT TECHNOLOGY INC.</div>
          </div>
        </div>
      </div>
      <ReCAPTCHA
        ref={captchaRef}
        size="invisible"
        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        badge="bottomleft"
      />
    </div>
  )
}
